import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { StatusCardProps as Props } from './types';

export const StatusCard = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('StatusCard', className)}
      sx={SX.root}
      severity="success"
      icon={false}
    >
      Your Plan has been successfully Downgraded.
    </Styled.Wrapper>
  );
});

StatusCard.displayName = 'StatusCard';
